import Special_live_kousei from "./special/live_kousei/main";

//specialページ汎用
const special = new Special_live_kousei();